/**
 * 環境定数定義
 * @author fumihiro.uchiyama
 */

export const formatDate = (d:Date, f:string):string => {
  return f
    .replace('yyyy', d.getFullYear() + '')
    .replace('MM', ('0' + (d.getMonth()+1)).substr(-2))
    .replace('M', (d.getMonth()+1) + '')
    .replace('dd', ('0' + d.getDate()).substr(-2))
    .replace('d', (d.getDate() + ''))
    .replace('HH', ('0' + d.getHours()).substr(-2))
    .replace('H', (d.getHours() + ''))
    .replace('mm', ('0' + d.getMinutes()).substr(-2))
    .replace('m', (d.getMinutes() + ''))
    .replace('ss', ('0' + d.getSeconds()).substr(-2))
    .replace('s', (d.getSeconds() + ''))
}

export const currentDate = (format:string):string => {
  return formatDate(new Date(), format)
}

/**
 * Dashboardホスト
 */
export const DASHBOARD_HOST = 'http://localhost:8091'
/**
 * Common Functionsホスト
 */
export const CMNFNC_HOST = '/api/cmnfnc';

/**
 * Common Master Base APIエンドポイント
 */
export const CMNFNC_BASE_API_ENDPOINT = `${CMNFNC_HOST}`

/**
 * Common Func Frontendホスト
 */
export const CMNFNC_FRONTEND = 'https://rel-api-planexec.fastretailing.com/www/fr-blu-cmnfnc-online/index.html';

/**
 * Logistics Frontendホスト
 */
export const LGSTCS_FRONTEND = 'undefined';

/**
 * Sales Plan Frontendホスト
 */
export const SALESPLN_FRONTEND = 'https://rel-api-planexec.fastretailing.com/www/fr-blu-salespln-online/index.html';

/**
 * Store Planning Inventory Control Frontendホスト
 */
export const STRPLNINVCNTL_FRONTEND = 'https://rel-api-planexec.fastretailing.com/www/fr-blu-strplninvcntl-online/index.html';

/**
 * Material Production Frontendホスト
 */
export const MATERIALPROD_FRONTEND = 'https://rel-api-planexec.fastretailing.com/www/fr-blu-materialprod-online/index.html';

/**
 * AUTH API ENDPOINT
 */
export const AUTH_ENDPOINT = '/api/auth';

/**
 * Dashboard Frontendホスト
 */
export const DASHBOARD_FRONTEND = 'https://rel-api-planexec.fastretailing.com/www/index.html';

/**
 * AIM Frontendホスト
 */
export const AIM_FRONTEND = 'https://rel-api-planexec.fastretailing.com/www/fr-blu-aim-online/index.html';

/**
 * INFORMATION FILE PATH
 */
export const INFORMATION_FILE_PATH = '/www/notification/index.html';


// WEBPACK FOOTER //
// ./src/environment.ts